const CHUNK_SIZE = 100;

export const chunkIdArray = (
    idArray: number[],
    chunkSize: number = CHUNK_SIZE,
    URLLength: number = 1800, // subtracting 200 for other base URL
): number[][] => {
    const MaxIdLength = Math.max(...idArray.map(id => id.toString().length));
    const maxIdInURL = Math.floor(URLLength / MaxIdLength);

    const effectiveMaxIdsPerChunk = Math.min(chunkSize, maxIdInURL);

    let chunks: number[][] = [];
    for (let i = 0; i < idArray.length; i += effectiveMaxIdsPerChunk) {
        chunks = [...chunks, idArray.slice(i, i + effectiveMaxIdsPerChunk)];
    }
    return chunks;
};
